import {CssTheme} from '@ui/themes/css-theme';

export interface CustomAuthPageRoute {
  id: number;
  type: 'login' | 'register';
  path: string;
}

export interface CustomAuthPagePlan {
  id?: number;
  product_id: number;
  price_id: number;
  trial_period?: number;
  voucher_enabled?: boolean;
  voucher_code?: string | null;
  sort_order?: number;
  product?: {
    id: number;
    name: string;
    description?: string | null;
  };
  price?: {
    id: number;
    nickname?: string | null;
    interval?: string | null;
    amount: number | string;
    currency: string;
  };
}

export interface CustomAuthPage {
  id: number;
  entity_name: string;
  theme_id: number;
  active: boolean;
  register_path: string | null;
  login_path: string | null;
  routes?: CustomAuthPageRoute[];
  plans?: CustomAuthPagePlan[];
  theme?: Pick<CssTheme, 'id' | 'name'> | null;
  created_at?: string;
  updated_at?: string;
}

export interface CustomAuthPagePayload {
  entity_name: string;
  theme_id: number | null;
  active: boolean;
  register_path: string;
  login_path: string;
  plans: {
    product_id: number | null;
    price_id: number | null;
    trial_period?: number | string | null;
    voucher_enabled?: boolean;
    voucher_code?: string | null;
    sort_order?: number;
  }[];
}

export interface BillingCatalogPrice {
  id: number;
  nickname?: string | null;
  interval?: string | null;
  amount: number | string;
  currency: string;
  label: string;
}

export interface BillingCatalogProduct {
  id: number;
  name: string;
  description?: string | null;
  prices: BillingCatalogPrice[];
}

export interface ResolvedCustomAuthPlan {
  product_id: number;
  price_id: number;
  trial_period?: number;
  product_name: string;
  product_description?: string | null;
  price_label: string;
  amount: number | string;
  currency: string;
  interval?: string | null;
  checkout_path: string;
  voucher_enabled?: boolean;
  voucher?: CustomAuthVoucherPreview | null;
}

export interface CustomAuthVoucherPreview {
  valid: boolean;
  message?: string;
  code?: string;
  discount_percentage?: number;
  original_price?: number;
  discount_amount?: number;
  final_price?: number;
  currency?: string;
  free_period_days?: number | null;
  free_period_ends_at?: string | null;
  recurring_amount?: number;
}

export interface ResolvedCustomAuthPage {
  id: number;
  entity_name: string;
  active: boolean;
  type: 'login' | 'register';
  register_path: string;
  login_path: string;
  theme: CssTheme | null;
  plans: ResolvedCustomAuthPlan[];
}

export function formatTrialPeriodLabel(days: number | string): string {
  switch (Number(days)) {
    case 30:
      return '1 mês (30 dias)';
    case 60:
      return '2 meses (60 dias)';
    case 90:
      return '3 meses (90 dias)';
    case 120:
      return '4 meses (120 dias)';
    case 150:
      return '5 meses (150 dias)';
    case 180:
      return '6 meses (180 dias)';
    default:
      return `${days} dias`;
  }
}

